import { RISK_STYLES, primaryStatus } from "@/lib/format";

export function RiskBadge({ status, size = "sm" }) {
  const s = RISK_STYLES[status] || RISK_STYLES["On Track"];
  const pad = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`risk-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-sm font-semibold border ${pad}`}
      style={{ color: s.fg, backgroundColor: s.bg, borderColor: s.fg }}
    >
      {s.label}
    </span>
  );
}

export function PrimaryBadge({ job, size = "sm" }) {
  const status = primaryStatus(job);
  const s = RISK_STYLES[status] || RISK_STYLES["On Track"];
  const pad = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  return (
    <span
      data-testid={`primary-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-sm font-semibold border ${pad}`}
      style={{ color: s.fg, backgroundColor: s.bg, borderColor: s.fg }}
    >
      {s.label}
    </span>
  );
}

export function StatusDot({ status }) {
  const s = RISK_STYLES[status] || RISK_STYLES["On Track"];
  return <span className="h-2 w-2 rounded-full inline-block" style={{ backgroundColor: s.fg }} />;
}
